<template>
  <div class="item">
    <div class="draft" v-if="!item.published">
      draft
    </div>
    <div
      class="image"
      :style="{ 'background-image': `url(${item.image})` }"
    ></div>
    <div class="body-container">
      <div class="title">
        {{ item.title }}
      </div>
      <div class="tags">
        <span v-for="tag in item.tags" :key="tag" class="tag">
          #{{ tag }}
        </span>
      </div>
      <div class="bottom">
        <div class="info">
          <span>{{ item.date }}</span
          ><br />
          <span>{{ item.author }}</span>
        </div>
        <!-- <div @click.stop="start" class="lottie-wrapper">
          <lottie
            :options="defaultOptions"
            :height="40"
            :width="40"
            v-on:animCreated="handleAnimation"
            style="margin-right: 0;"
          />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import BgTypography from "@/directives/bg-typography";
import Lottie from "vue-lottie";
import * as animationData from "./favorite.json";
import BgField from "@/components/bg-field";
import BgInput from "@/components/bg-input";
import Article from "@/components/article-card";

export default {
  props: ["item"],
  directives: {
    BgTypography,
  },
  components: {
    Lottie,
    BgField,
    BgInput,
    Article,
  },
  data() {
    return {
      defaultOptions: {
        animationData: animationData.default,
        loop: false,
        autoplay: false,
      },
      animationSpeed: 1,
      direction: 1,
      searchString: "",
    };
  },
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim;
    },
    start() {
      if (this.direction === 1) {
        this.anim.play();
      } else {
        this.anim.stop();
      }
      this.direction = this.direction * -1;
    },
  },
};
</script>

<style lang="scss" scoped>
.items {
  display: flex;
  gap: 25px;
}
.item {
  background-color: white;
  width: 300px;
  height: 300px;
  border-radius: 8px;
  cursor: pointer;
  position: relative;

  .draft {
    position: absolute;
    background-color: #ff14a9;
    padding: 7px 20px;
    left: -5px;
    top: 16px;
    border-radius: 6px;
    font-weight: 600;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    font-size: 11pt;
  }

  &:hover {
    box-shadow: 0px 0px 0px 3px rgba(209, 219, 229, 1);
  }

  .image {
    height: 70px;
    border-radius: 8px;
    width: 300px;
    background-size: cover;
    background-position: center;
  }
  .body-container {
    padding: 15px 25px;

    .title {
      font-size: 16pt;
      font-weight: 600;
      padding-bottom: 10px;
      border-bottom: 1px solid #ebebef;
      height: 112px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
    }

    .tags {
      margin-top: 10px;
      height: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;

      .tag {
        font-size: 12pt;
        color: #636383;
        font-weight: 600;
      }
    }

    .bottom {
      font-size: 10pt;
      margin-top: 10pt;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .lottie-wrapper {
        width: 60px;
      }
    }
  }
}
</style>
